<template>
  <EmdFormGroup
    :label="$t('professional-occupation')"
    :state="getState($v.recipient.professional_occupation)"
    :feedbacks="feedbacks($v.recipient.professional_occupation)"
    required
  >
    <EmdInput
      @input="() => $v.recipient.professional_occupation.$touch()"
      v-model="recipient.professional_occupation"
      name="professional-occupation"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { managingPartners } from '../validations'
export default {
  name: 'ProfessionalOccupationInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    professional_occupation: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: managingPartners }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "professional-occupation": "Área de atuação ou função desempenhada"
    },
    "en-US": {
      "professional-occupation": "Area of activity or function performed"
    }
  }
</i18n>
